module.exports = __webpack_public_path__ + "img/procurement.d08c880f.png";